import {
  MenuItem as MuiMenuItem,
  type MenuItemProps as MuiMenuItemProps,
  styled,
} from '@mui/material';

/**
 * Props for configuring a card menu item component from [MicroLibraryCoreUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryCoreUI)
 *
 * @property {MuiMenuItemProps} props - The props for the menu item.
 */

const MenuItem = ({ ...props }: MuiMenuItemProps) => {
  return <MuiMenuItem tabIndex={0} {...props} />;
};

export const CardMenuItem = styled(MenuItem)<MuiMenuItemProps>(() => ({
  paddingLeft: '29px',
  paddingRight: '29px',
  paddingTop: '10px',
  paddingBottom: '10px',
}));
